import React from 'react';

import {
  BloodCard,
  MedicineCard,
  MedicineMixCard,
  OtherCard,
} from './card-item-content';
import type { CardItemProps } from './card-item-content';

const CardItem: React.FC<CardItemProps> = ({ type = 'medicine', data, patientId, upn, refetch }) => {
  switch (type) {
    case 'blood':
      return <BloodCard data={data} patientId={patientId} refetch={refetch} />;
    case 'other':
      return <OtherCard data={data} patientId={patientId} refetch={refetch} />;
    case 'medicine-mix':
      return <MedicineMixCard data={data} patientId={patientId} upn={upn} refetch={refetch} />;
    case 'medicine':
    default:
      return <MedicineCard data={data} patientId={patientId} upn={upn} refetch={refetch} />;
  }
};

export type {
  CardItemData,
  CardItemProps,
  CardItemVariant,
  OrderDetail,
  OtherTreatment,
} from './card-item-content';

export default CardItem;
